import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    promotions: [],
    totalItems:0,
    promotion: {}
};

const getters = {
    index: state => promotionId => state.promotions.findIndex(i => i.promotionId === promotionId)
};

const mutations = {
    setPromotions: (state, r) => (state.promotions = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    setPromotion: (state, r) => (state.promotion = r),
    add: (state, r) => state.promotions.unshift(r),
    edit: (state, { index, r }) => state.promotions.splice(index, 1, r),
    delete: (state, index) => state.promotions.splice(index, 1),
    approval: (state, index) => state.promotions[index].status = status.active,

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.promotions.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setPromotions", response.data.promotions);
            commit("setTotalItems", response.data.totalItems);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.promotions.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.promotion);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.promotions.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async approval({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.promotions.approval(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setPromotion", {});
            startLoading()
            const response = await dataService.promotions.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setPromotion", response.data.promotion);
         
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.promotions.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.promotion);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.promotions.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, r: response.data.promotion });

          /*  return Promise.resolve()*/
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
     async complete({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.promotions.complete(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, r: response.data.promotion });

          /*  return Promise.resolve()*/
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async employeesSearch(_, employeeId) {
        try {

            // startLoading()
            const response = await dataService.promotions.employeesSearch(employeeId);
            // stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            } 
       
            return Promise.resolve(response.data.employee);

        } catch (error) {
            // stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
